import React, { Suspense, lazy } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Loader } from 'components/UIElements'
import { selectViewActions } from '../modules/NewConsent'

const ChoicesList = lazy(() =>
  import(/* webpackChunkName: "dnd-kit-survey" */ '../../../../../../Instruments/routes/Instrument/routes/EditSurvey/components/ChoicesList'),
)

class SelectView extends React.Component {
  componentDidUpdate(prevProps) {
    const { item } = this.props
    if (prevProps.item.type !== item.type) {
      this.el?.querySelector('textarea')?.focus()
    }
  }

  shouldCancelStart = e => {
    const { isActive } = this.props
    return !isActive || !e.target.className.includes('choice-grab-icon')
  }

  onAddChoice = idx => {
    const { addChoice, item, itemId } = this.props
    return () => {
      addChoice(itemId, item.choices_order.length, idx)
    }
  }

  render() {
    const { itemId, moveChoice, preview } = this.props
    return (
      <div
        ref={el => {
          this.el = el
        }}
        className='multi-choice-container'>
        <Suspense fallback={<div className='flexed center-justified' style={{ minHeight: 60 }}><Loader inContainer size={20} /></div>}>
          <ChoicesList
            isConsent
            preview={preview}
            onSortEnd={({ oldIndex, newIndex }) => moveChoice(itemId, oldIndex, newIndex)}
            lockAxis='y'
            lockToContainerEdges
            helperClass='sortableHelper choices'
            shouldCancelStart={this.shouldCancelStart}
            onAddChoice={this.onAddChoice}
            {...this.props}
          />
        </Suspense>
      </div>
    )
  }
}

export default connect(null, selectViewActions)(SelectView)

SelectView.propTypes = {
  item: PropTypes.object,
  itemId: PropTypes.string,
  moveChoice: PropTypes.func,
  addChoice: PropTypes.func,
  isActive: PropTypes.bool,
  preview: PropTypes.bool,
}
